import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext, useEffect, useState, useRef, useCallback } from 'react';
import { Icon } from '../index';
import Button from '../button/button';
import ReactDOM from 'react-dom';
import { tuple } from '../_utils/type';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
import Draggable from 'react-draggable';
import { getLangMsg } from '../locale/locale';
import { useHideDocumentScrollBar } from '../_utils/hooks';
export var ConfirmModalTypes = ['confirm', 'normal'];
export var ModalTypes = tuple('confirm', 'warning', 'error', 'normal');

var Modal = function Modal(props) {
  var _classNames4, _context2, _context3;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var modalProps = getCompProps('Modal', userDefaultProps, props); // 属性需要合并一遍用户定义的默认属性

  var body = modalProps.body,
      bodyClassName = modalProps.bodyClassName,
      bodyStyle = modalProps.bodyStyle,
      cancelButtonProps = modalProps.cancelButtonProps,
      cancelText = modalProps.cancelText,
      className = modalProps.className,
      closable = modalProps.closable,
      closeIcon = modalProps.closeIcon,
      destroyOnClose = modalProps.destroyOnClose,
      draggable = modalProps.draggable,
      focusTriggerAfterClose = modalProps.focusTriggerAfterClose,
      footer = modalProps.footer,
      footerClassName = modalProps.footerClassName,
      footerStyle = modalProps.footerStyle,
      footerBtnOrder = modalProps.footerBtnOrder,
      getContainer = modalProps.getContainer,
      height = modalProps.height,
      keyboard = modalProps.keyboard,
      mask = modalProps.mask,
      maskClosable = modalProps.maskClosable,
      maskStyle = modalProps.maskStyle,
      okButtonProps = modalProps.okButtonProps,
      okText = modalProps.okText,
      onCancel = modalProps.onCancel,
      onOk = modalProps.onOk,
      customPrefixcls = modalProps.prefixCls,
      title = modalProps.title,
      titleIcon = modalProps.titleIcon,
      type = modalProps.type,
      visible = modalProps.visible,
      width = modalProps.width,
      showline = modalProps.showline;
  var isForceController = visible !== undefined;

  var _useState = useState(isForceController ? visible : true),
      _useState2 = _slicedToArray(_useState, 2),
      innerVisible = _useState2[0],
      setInnerVisible = _useState2[1]; // 需要根据visible来判断，不能一开始为true再去设置false


  var previousActiveElement = useRef(null);
  var containerRef = useRef(null);
  var modalPrefixCls = getPrefixCls(prefixCls, 'modal', customPrefixcls);
  devWarning(ModalTypes.indexOf(type) === -1, 'modal', "cannot found modal type '".concat(type, "'"));
  var modalContainer = typeof getContainer === 'function' ? getContainer() : getContainer;

  if (modalContainer !== false && !(modalContainer instanceof HTMLElement)) {
    try {
      modalContainer = document.querySelector(modalContainer);
    } catch (error) {
      devWarning(true, 'modal', 'getContainer"s returnValue/value is not a correct CSSSelector');
    }

    modalContainer = document.body;
  }

  useHideDocumentScrollBar(isForceController ? !!visible : !!innerVisible, modalContainer === document.body, !!mask);
  var closeModal = useCallback(function () {
    setInnerVisible(false);
  }, []);
  var proxyCloseModal = useCallback(function (onDoingAction, event) {
    onDoingAction && onDoingAction(event);

    if (isForceController) {
      return;
    }

    closeModal();
  }, [isForceController, closeModal]);
  var escapeToCloseModal = useCallback(function (evt) {
    var _context;

    // In Internet Explorer 9 and Firefox 36 and earlier, the Esc key returns "Esc" instead of "Escape"
    if (_includesInstanceProperty(_context = ['Escape', 'Esc']).call(_context, evt.key)) {
      proxyCloseModal(onCancel);
    }
  }, [proxyCloseModal, onCancel]);
  var enterToCloseModal = useCallback(function (evt) {
    if (evt.key === 'Enter' && evt.target === containerRef.current) {
      proxyCloseModal(onOk); // 无效
      // evt.stopPropagation()
    }
  }, [proxyCloseModal, onOk]);

  var isConfirmType = _includesInstanceProperty(ConfirmModalTypes).call(ConfirmModalTypes, type);

  var isNormalBtn = !footerBtnOrder || footerBtnOrder === 'normal';

  var finalCancelButtonProps = _extends({
    onClick: useCallback(function (event) {
      proxyCloseModal(onCancel, event);
    }, [onCancel, proxyCloseModal]),
    type: 'second',
    className: classNames("".concat(modalPrefixCls, "-cancel-btn"), _defineProperty({}, "".concat(modalPrefixCls, "-margin-btn"), isConfirmType && isNormalBtn))
  }, cancelButtonProps);

  var finalOkButtonProps = _extends({
    onClick: useCallback(function (event) {
      proxyCloseModal(onOk, event);
    }, [onOk, proxyCloseModal]),
    type: _includesInstanceProperty(ConfirmModalTypes).call(ConfirmModalTypes, type) ? 'primary' : 'second',
    className: classNames("".concat(modalPrefixCls, "-ok-btn"), _defineProperty({}, "".concat(modalPrefixCls, "-margin-btn"), isConfirmType && !isNormalBtn))
  }, okButtonProps);

  var generatorFooterByType = useCallback(function () {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'confirm';

    switch (type) {
      case 'error':
      case 'warning':
        {
          return /*#__PURE__*/React.createElement("div", {
            className: "".concat(modalPrefixCls, "-iknow-node")
          }, /*#__PURE__*/React.createElement(Button, _extends({}, finalOkButtonProps), okText || getLangMsg('Modal', 'iknowText')));
        }

      case 'confirm':
      case 'normal':
      default:
        {
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "".concat(modalPrefixCls, "-cancel-node")
          }, /*#__PURE__*/React.createElement(Button, _extends({}, finalCancelButtonProps), cancelText || getLangMsg('Modal', 'cancelText'))), /*#__PURE__*/React.createElement("div", {
            className: "".concat(modalPrefixCls, "-ok-node")
          }, /*#__PURE__*/React.createElement(Button, _extends({}, finalOkButtonProps), okText || getLangMsg('Modal', 'okText'))));
        }
    }
  }, [modalPrefixCls, okText, cancelText, finalCancelButtonProps, finalOkButtonProps]);
  useEffect(function () {
    if (isForceController) {
      // 强控制下只有下面该条件成立获取焦点
      if (focusTriggerAfterClose && visible === true) {
        !previousActiveElement.current && (previousActiveElement.current = document.activeElement);
      }
    } else {
      // 不控制时, 只有下面该条件成立获取焦点
      focusTriggerAfterClose && !previousActiveElement.current && (previousActiveElement.current = document.activeElement);
    }

    return function () {
      if (focusTriggerAfterClose && previousActiveElement.current) {
        // 这里可能有种情况，如果回车触发弹窗，由于回车又可以关闭弹窗，会导致连续触发回车
        ;
        previousActiveElement.current.focus();
        previousActiveElement.current = null;
      }
    };
  }, [focusTriggerAfterClose, visible, isForceController]);
  useEffect(function () {
    if (keyboard) {
      document.body.addEventListener('keydown', escapeToCloseModal);
    }

    return function () {
      document.body.removeEventListener('keydown', escapeToCloseModal);
    };
  }, [keyboard, escapeToCloseModal, proxyCloseModal, onCancel]);
  var handleMaskClick = useCallback(function () {
    if (maskClosable) {
      proxyCloseModal(onCancel);
    }
  }, [proxyCloseModal, onCancel, maskClosable]);
  var modalClasses = classNames(modalPrefixCls, className, _defineProperty({}, "".concat(modalPrefixCls, "-container"), true));
  var headerClass = "".concat(modalPrefixCls, "-header");
  var container = /*#__PURE__*/React.createElement("div", {
    className: classNames((_classNames4 = {}, _defineProperty(_classNames4, "".concat(modalPrefixCls, "-container-box"), true), _defineProperty(_classNames4, "".concat(modalPrefixCls, "-has-container-box"), modalContainer), _defineProperty(_classNames4, "".concat(modalPrefixCls, "-showline"), showline), _classNames4)),
    style: {
      width: width,
      height: height
    },
    ref: containerRef,
    tabIndex: -1,
    onKeyDown: enterToCloseModal
  }, /*#__PURE__*/React.createElement("div", {
    className: headerClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(modalPrefixCls, "-title-container")
  }, titleIcon !== undefined ? titleIcon : type !== 'normal' && /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(modalPrefixCls, "-title-icon"), _defineProperty({}, "modal-".concat(type, "-title-icon-bgcolor"), type))
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(modalPrefixCls, "-title")
  }, title)), closable && /*#__PURE__*/React.createElement("div", {
    className: "".concat(modalPrefixCls, "-close-icon"),
    onClick: function onClick() {
      return proxyCloseModal(onCancel);
    }
  }, closeIcon || /*#__PURE__*/React.createElement(Icon, {
    type: "close"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(modalPrefixCls, "-body"), bodyClassName),
    style: bodyStyle
  }, body), footer !== null && /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(modalPrefixCls, "-footer"), _concatInstanceProperty(_context2 = "".concat(modalPrefixCls, "-")).call(_context2, type, "-footer"), footerClassName),
    style: _extends({
      flexDirection: !footer && (!footerBtnOrder || footerBtnOrder === 'normal') ? 'row' : 'row-reverse'
    }, footerStyle || {})
  }, footer || generatorFooterByType(type))); // 没有容器应该是不用居中的
  // 但仍可拖拽

  var defaultPosition = modalContainer ? {
    x: -(width / 2),
    y: -(height / 2)
  } : {
    x: 0,
    y: 0
  };
  var isHidden = !destroyOnClose && !(isForceController ? visible : innerVisible);
  var compStyle = isHidden ? {
    display: 'none'
  } : {};
  var comp = /*#__PURE__*/React.createElement("div", {
    className: modalClasses,
    style: compStyle
  }, mask && /*#__PURE__*/React.createElement("div", {
    onClick: handleMaskClick,
    className: "".concat(modalPrefixCls, "-mask"),
    style: maskStyle
  }), /*#__PURE__*/React.createElement(Draggable, {
    defaultPosition: defaultPosition,
    handle: ".".concat(headerClass),
    disabled: !draggable,
    cancel: _concatInstanceProperty(_context3 = ".".concat(modalPrefixCls, "-title-container, .")).call(_context3, modalPrefixCls, "-close-icon")
  }, container));
  var renderComp = ((isForceController ? visible : innerVisible) || !destroyOnClose) && comp;
  if (modalContainer && renderComp) return /*#__PURE__*/ReactDOM.createPortal(renderComp, modalContainer);
  return renderComp || null;
};

Modal.displayName = 'Modal';
export default Modal;